/*
 * discover-lx1-feature-videos.js — the six feature videos in sections/discover-lx1-features.liquid.
 * Styles: assets/discover-lx1-feature-videos.css. No dependencies.
 *
 * Desktop (fine pointer): the video marked data-hv-role="hero" loops; hovering another video plays it instead
 * (from the start) and leaving it returns to the hero video. Touch: every video autoplays muted. Nothing plays
 * when the visitor prefers reduced motion. Moved from an inline <script> on the Instant page.
 */
(function () {
  const GROUP = 'lx1-features';
  const SELECTOR = `.hv-video[data-hv-group="${GROUP}"]`;
  const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  const videos = Array.from(document.querySelectorAll(SELECTOR));
  if (!videos.length) return;

  const hero = videos.find((v) => v.dataset.hvRole === 'hero') || null;

  videos.forEach((v) => {
    v.muted = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'metadata');
    const wrap = v.closest('.hv-wrap');
    if (wrap && v === hero) wrap.classList.add('hv-hero');
  });

  function wrapOf(v) {
    return v.closest('.hv-wrap');
  }
  function setUI(v, on) {
    const w = wrapOf(v);
    if (w) w.classList.toggle('hv-playing', !!on);
  }

  function stop(v, reset = true) {
    v.pause();
    setUI(v, false);
    if (reset) {
      try {
        v.currentTime = 0;
      } catch (e) {}
    }
  }

  function play(v) {
    videos.forEach((x) => {
      if (x !== v) stop(x, true);
    });
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
    setUI(v, true);
  }

  if (isDesktop) {
    videos.forEach((v) => {
      if (v !== hero) stop(v, true);
    });
    if (hero) play(hero);

    document.addEventListener(
      'mouseover',
      (e) => {
        const v = e.target.closest ? e.target.closest(SELECTOR) : null;
        if (!v || v === hero) return;
        play(v);
      },
      { passive: true },
    );

    document.addEventListener(
      'mouseout',
      (e) => {
        const v = e.target.closest ? e.target.closest(SELECTOR) : null;
        if (!v || v === hero) return;
        const related = e.relatedTarget;
        if (related && v.contains && v.contains(related)) return;
        stop(v, true);
        if (hero) play(hero);
      },
      { passive: true },
    );
  } else {
    videos.forEach((v) => {
      v.setAttribute('autoplay', '');
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    });
  }
})();
